import React, { useState, lazy, useEffect } from 'react';
import { MainContent, CommonContent } from '../../css/css';
import ContactList from './components/contactList';
import { useUpdateEffect } from '../../hooks/useUpdateEffect';
import { usePermission } from '../../hooks/usePermission';
import {
  ConversationWrapper,
  LeftPart,
  RightPart,
  ConversationContent,
  ConversationBottom,
  WhiteBackground,
  SearchWrapper,
  DateName,
  TimeClose,
  SearchTime,
} from './conversation-module-ui';
import api from '@/apis/pc/conversation/conversation';
import { Spin, Input, DatePicker } from 'antd';
import { useRef } from 'react';
import ChatLog from '../chat-log/chatLog';
import { BoxHeader, ButtonItem } from './conversation-module-ui';
import Show from '../show/show';
import userApi from '@/apis/pc/user/user'
import CloseIcon from '../../img/close.png';
import { createGlobalStyle } from 'styled-components';
import { scrollToFirstMessage } from '@/pages/conversation/conversation-utils';
const { RangePicker } = DatePicker;
const { Search } = Input;

const GlobalStyle = createGlobalStyle`
#zmageImage{
  z-index: 1002 !important;
}
#zmageControl {
  background-color: #111 !important;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  z-index: 1002 !important;
  #zmageControlClose{
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  }
  path{
    fill: #fff;
  }
}
#zmageBackground{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(17, 17, 17, .32) !important;
  z-index: 1001 !important;
}
`;
// import { connect } from 'react-redux';
// import {getMessageSettingsOpenByUser} from '@/actions/messageSettingsOpenByUser'

// const mapDispatchToProps = { getMessageSettingsOpenByUser }
const tabTypeArr = [
  {
    type: 1,
    name: '全部',
  },
  {
    type: 2,
    name: '文件',
  },
  {
    type: 3,
    name: '图片/视频',
  },
];
const NoPermission = lazy(() =>
  import('@/pages/no-permission/no-permission').then()
); //缺省页

/**
 * @设计理念: 整个消息存档维护3个参数，无论是在联系人列表，搜索结果列表，右侧搜索都是统一的逻辑
 * @params: operateData（当前查看的员工, 联系人列表使用）
 * @params: currentSession（当前操作的会话）
 * @params: currentMessage（当前操作的消息）
 */
const Conversation = (props) => {
  const { isGroup, groupId } = props;
  const [currentSession, setCurrentSession] = useState({}); // 当前正在操作的会话，决定了聊天记录栏显示的内容
  const [currentMessage, setCurrentMessage] = useState({}); // 当前操作的消息
  const initCondition = { pageSize: 30, messageType: 1, pageType: 1 }; // messageType 1 全部 2 文件 3 图片
  const [chatSearchCondition, setChatSearchCondition] = useState(initCondition);
  const [chatLog, setChatLog] = useState({ list: [] });
  const [isClose, setIsClose] = useState(false); // 右侧栏默认收起状态
  const [pageType, setPageType] = useState('contactList');
  const [searchCondition, setSearchCondition] = useState({});
  const [scrollType, setScrollType] = useState('bottom');
  const pathParms = props.location?.pathname?.split('/');
  const { hasPermission } = usePermission('查看消息存档');
  const [chatType, setChatType] = useState('1');
  const [selectFlag, setSelectFlag] = useState(true);
  const [uid, setUid] = useState('');
  const [type, setType] = useState(1);
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [userList, setUserList] = useState([])
  const [currentUser, setCurrentUser] = useState({})
  const [sessionList, setSessionList] = useState([])
  const inputKey = useRef(null);
  const handleType = (value) => {
    setType(value);
    if (value !== type) {
      delete paramRef.current.content;
      delete paramRef.current.startTime;
      delete paramRef.current.endTime;
    }
    if(!paramRef.current?.sessionId) {
      return
    }
    getMessageApi({
      ...paramRef.current,
      pageType: 1,
      pageNum: 1,
      messageType: value,
    });
  };
  const paramRef = useRef({});
  const dataRef = useRef({ startTime: '', endTime: '' }).current

  const initApi = (isGroup, params = []) => {
    if(isGroup) {
      return new Promise((resolve) => resolve(true))
    }
    else {
      return userApi.getCovUsers(params)
    }
  }

  useEffect(() => {
    if(props?.wxUserid && !isGroup) {
      getUserList({ requestParams: props?.wxUserid })
    }
  }, [props?.wxUserid])

  const getUserList = (params = {}) => {
    setLoading(true);
    if (!isGroup) {
      api.getSessionId({
        extendUserId: props.wxUserid,
        searchNameParam: '',
        type: 1,
        chatType: 1,
        pageNum: 1,
        pageSize: 100,
        customerDetailFlag: false,
        // 企微客户看的是 客户 与公司销售之间的会话,extendUserType 1 是客户 2 是员工
        extendUserType: 1,
      }).then(res => {
        let findUsers = res?.data?.list?.map(item => item?.uid)
        // 选中人后从人的uid匹配res?.data?.list中的某一条 获取到sessionId
        setSessionList(res?.data?.list || [])
        if(findUsers?.length === 0) {
          findUsers = [-1]
        }
        initApi(isGroup, findUsers)
          .then((res) => {
            const userListData = res?.data;
            // 不再使用权限判断
            setUserList(userListData);
            const current =
              userListData?.find(
                (item) => Number(item?.uid) === Number(window?.current_user?.uid)
              ) ||
              userListData?.[0] ||
              {};
            setCurrentUser(current);
            if (current?.uid) {
              changeSessionOrMessage({ setType: 'session', ...current });
            }
          })
          .finally(() => {
            setLoading(false);
          });
      });
      return;
    } else if (groupId) {
      initApi(isGroup, params?.requestParams)
        .then(() => {
          api
            .externalGroupList({
              groupId,
              chatType: 2,
              pageNum: 1,
              pageSize: 10,
              type: 1,
              extendUserType: 1,
            })
            .then((res) => {
              if (res.success) {
                if (!res?.data?.list?.[0]) {
                  setChatLog({ list: [] });
                  return;
                }
                getMessageApi({
                  sessionId: res?.data?.list?.[0]?.sessionId,
                  messageType: 1,
                  pageSize: 30,
                  pageType: 1,
                  pageNum: 1,
                  uid: window?.current_user?.uid || 5536806,
                });
              } else {
                setChatLog({ list: [] });
              }
            }).finally(() => {
              setLoading(false)
            });
        })
    }
  };

  useEffect(() => {
    if(isGroup) {
      getUserList()
    }
  }, []);

  // 改变会话或者当前的消息
  const changeSessionOrMessage = (value) => {
    // setType session 表示设置session并根据session进行搜索，
    // type onlySession 表示只设置session, type message 表示根据message搜索 type clear 为清空记录
    // setUid(value.uid)
    if (value.setType === 'message') {
      setCurrentMessage(value);
      setScrollType('message');
    } else if (value.setType === 'clear') {
      setCurrentSession(value);
      setChatLog({ list: [] });
      setScrollType('bottom');
    } else {
      setCurrentSession(value);
      // setIsClose(true);
      setScrollType('bottom');
    }
    setIsClose(true);
    setType(1);
    setStartTime('');
    setEndTime('');
    // inputKey.current.state && (inputKey.current.state.value = '');
    delete paramRef.current.messageType;
    delete paramRef.current.content;
    delete paramRef.current.startTime;
    delete paramRef.current.endTime;
    setTimeout(() => {
      setIsClose(false);
    }, 100);
  };
  const getMessageApi = (params) => {
    paramRef.current = params;
    if(!params?.sessionId) {
      return
    }
    setLoading(true);
    api.chatSearch(params).then((res) => {
      const isChangeTime = !dataRef.startTime && !dataRef.endTime && params?.startTime && params?.endTime
      setTimeout(() => {
        const cloneParams = JSON.parse(JSON.stringify(params))
        if(isChangeTime) {
          cloneParams.top = 1
        }
        !startTime && scrollToFirstMessage(cloneParams, res.data.list)
        dataRef.startTime = params?.startTime
        dataRef.endTime = params?.endTime
      }, 0)
      setLoading(false);
      if (res.code === 0) {
        {/*pageType为1表示初始，2表示下拉，3表示向上加载*/}
        let pageNum = res?.data?.pageNum || 1
        if (pageNum === 1) {
          setChatLog(res.data);
        } else {
          // 选中了时间 正序展示 同时定位到最早的消息 下滑加载更新的消息
          let temp = [...chatLog.list, ...res.data.list]
          setChatLog({ ...res.data, list: temp });
        }
      } else {
        setChatLog({ list: [] });
      }
    });
  };

  // 查找聊天记录（接口3）
  const chatSearch = (params) => {
    const { uid } = currentSession;
    const wxUserId = props.wxUserId;
    // http://zentao.weiwenjia.com/bug-view-52359.html
    if(!uid) {
      console.log("/api/traffic/chat/session/extendUserList为空 拿不到uid")
      return
    }
    let sessionId = sessionList?.find(item => +item?.uid === +uid)?.sessionId
    if(!sessionId) {
      return
    }
    let messageParams = {
      sessionId,
      ...chatSearchCondition,
      extendUserId: searchCondition.extendUserId,
      uid: props.uid,
    };
    if (props.uid) {
      delete messageParams.extendUserId;
    } else {
      delete messageParams.uid;
    }
    if (!messageParams.sessionId) {
      setChatLog({ list: [] });
      Reflect.deleteProperty(paramRef.current, 'sessionId')
      return;
    }
    getMessageApi(messageParams);
  };

  useUpdateEffect(() => {
    chatSearch();
  }, [chatSearchCondition]);

  useUpdateEffect(() => {
    if (currentSession.setType === 'session') {
      setChatSearchCondition(initCondition);
    }
    if (currentSession.setType === 'clear') {
      setChatLog({ list: [] });
    }
  }, [currentSession]);

  useUpdateEffect(() => {
    setChatSearchCondition({
      ...initCondition,
      ...currentMessage,
      content: searchCondition.content,
      messageType: 1,
      messageId: currentMessage.id,
      sessionId: currentMessage.session,
    });
  }, [currentMessage]);

  const loadMore = (value) => {
    getMessageApi({
      ...paramRef.current,
      // ...value,
      pageType: 1,
      pageNum: (chatLog?.pageNum || 1) + 1,
      pageSize: 30
    });
  };
  const handleSearchValue = (value) => {
    getMessageApi({
      ...paramRef.current,
      pageNum: 1,
      content: value,
    });
  };
  const handleTimeChange = (value, dateString) => {
    setChatLog({ list: [] })
    setStartTime(dateString?.[0]);
    setEndTime(dateString?.[1]);
    getMessageApi({
      ...paramRef.current,
      pageNum: 1,
      startTime: dateString?.[0],
      endTime: dateString?.[1],
    });
  };
  const handleCloseTime = () => {
    setChatLog({ list: [] })
    setStartTime('');
    setEndTime('');
    getMessageApi({
      ...paramRef.current,
      startTime: '',
      endTime: '',
      pageNum: 1,
      pageType: 1
    });
  };
  return (
    <MainContent>
      <GlobalStyle />
      <WhiteBackground />
      {hasPermission ? (
        <>
          <ConversationWrapper>
            <Show show={!isGroup}>
              <LeftPart>
                {pageType === 'contactList' && (
                  <ContactList
                    {...props}
                    loading={loading}
                    handleChange={changeSessionOrMessage}
                    shouldSelectFirst={true}
                    session={currentSession}
                    pathParms={pathParms}
                    selectFlag={selectFlag}
                    handleChatType={(res) => {
                      setChatType(res);
                    }}
                    handleSetUid={(val) => {
                      if (!selectFlag) {
                        setUid('');
                      } else {
                        setUid(val);
                      }
                    }}
                    searchCondition={searchCondition}
                    userList={userList}
                    currentUser={currentUser}
                  />
                )}
              </LeftPart>
            </Show>
            <RightPart>
              <Spin spinning={loading}>
                <ConversationContent style={{ width: '100%', flex: 1 }}>
                  <BoxHeader className='traff-boxHeader'>
                    {tabTypeArr?.map((item) => (
                      <ButtonItem
                        key={item.type}
                        className={type === item.type ? 'active' : ''}
                        onClick={() => handleType(item.type)}
                      >
                        {item.name}
                      </ButtonItem>
                    ))}
                  </BoxHeader>
                  <Show show={![2, 3].includes(type)}>
                    <SearchWrapper>
                      <Search
                        placeholder='请输入关键词'
                        onSearch={handleSearchValue}
                        style={{ width: 200 }}
                        maxLength={50}
                        ref={inputKey}
                      />
                      <div className='date-time'>
                        <RangePicker
                          onChange={handleTimeChange}
                          inputReadOnly='true'
                          value={null}
                          bordered={false}
                        />
                      </div>
                    </SearchWrapper>
                    <Show show={startTime && endTime}>
                      <SearchTime>
                        {startTime} ~ {endTime}
                        <TimeClose src={CloseIcon} onClick={handleCloseTime} />
                      </SearchTime>
                    </Show>
                  </Show>
                  <ChatLog
                    log={chatLog}
                    loadMore={loadMore}
                    startTime={startTime}
                    endTime={endTime}
                    type={type}
                    scrollType={scrollType}
                    height={60}
                    reverse={Boolean(startTime)}
                    inverse={!startTime}
                  />
                </ConversationContent>
              </Spin>
            </RightPart>
          </ConversationWrapper>
          <ConversationBottom />
        </>
      ) : (
        <NoPermission />
      )}
    </MainContent>
  );
};

export default Conversation;
// export default connect(mapStateToProps, mapDispatchToProps)(Conversation);
